import React from 'react';
import { Link } from 'react-router-dom';

const TabNavigation = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="dash-tabs">
      {tabs.map((tab) => (
        <Link
          key={tab.id}
          to={'#'}
          className={`dash-tab ${activeTab === tab.id && 'active'}`}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </Link>
      ))}
    </div>
  );
};

export default TabNavigation; 